export default __webpack_public_path__ + "static/media/signedIn.48827cea.svg";